// App.tsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CssBaseline, GlobalStyles, Box } from "@mui/material";

import Home from "./pages/Home";
import About from "./pages/About";
import Dashboard from "./pages/Dashboard";
import Comparison from "./pages/Comparison";
import ResearchPaper from "./pages/ResearchPaper";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Glossary from "./pages/Glossary";

const App: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <GlobalStyles
  styles={{
    html: {
      margin: 0,
      padding: 0,
    },
    body: {
      margin: "0 !important",
      padding: "0 !important",
    },
    "#root": {
      margin: 0,
      padding: 0,
    },

    /* 🔥 THIS FIXES THE GAP */
    "body > div": {
      margin: 0,
      padding: 0,
    },

    /* prevent margin collapse */
    main: {
      display: "flow-root",
    },
  }}
/>
      <BrowserRouter>
        {/* no fixed height, no overflow hidden */}
       <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Header />
          {/* let main size naturally; no flexGrow */}
          <Box component="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/comparison" element={<Comparison/>} />
              <Route path="/paper" element={<ResearchPaper />} />
              <Route path="/glossary" element={<Glossary />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
            </Routes>
          </Box>
          {/* footer will now appear right after content and scroll away */}
          <Footer />
        </Box>
      </BrowserRouter>
    </>
  );
};

export default App;
